<template>
  <div class="container">
    <div class="school-body">
      <el-row>
        <el-col :span="24">
          <div class="classwrapper">
            <el-row>
              <el-col :span="24">
                <div class="classheader">
                  <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '/school-home-page/basicMaterial' }">返回</el-breadcrumb-item>
                    <el-breadcrumb-item>物料详情</el-breadcrumb-item>
                  </el-breadcrumb>
                </div>
              </el-col>
            </el-row>

            <el-row style="margin: 20px">
              <el-col :span="6">
                <div class="classimg_wrapper" :style="{
          backgroundImage: 'url(' + curriculumInfo.img_url + ')',
        }"></div>
              </el-col>
              <el-col :span="18">
                <div class="classdesc_wrapper">
                  <el-row>
                    <el-col :span="24">
                      <div class="classdesc_title" style="font-weight: 500">{{ curriculumInfo.title }}</div>
                    </el-col>
                  </el-row>

                  <el-row style="line-height: 25px">
                    <el-col :span="2">
                      <div class="grid-content bg-purple" style="font-size: 14px">使用场景:</div>
                    </el-col>
                    <el-col :span="22">
                      <div class="grid-content bg-purple-light" style="font-size: 14px">{{ curriculumInfo.sceneName }}
                      </div>
                    </el-col>
                  </el-row>
                  <el-row style="line-height: 25px">
                    <el-col :span="2">
                      <div class="grid-content bg-purple" style="font-size: 14px">物料类型:</div>
                    </el-col>
                    <el-col :span="22">
                      <!-- {{ curriculumInfo.typeNameArr.typeName }} -->
                      <div class="grid-content bg-purple-light">
                        <span class="tagName" v-for="item of tagList" :key="item.id" style="margin-right:10px">{{
          item.typeName }}</span>
                      </div>
                    </el-col>
                  </el-row>

                  <el-row style="line-height: 25px">
                    <el-col :span="2">
                      <div class="grid-content bg-purple" style="font-size: 14px">物料简介:</div>
                    </el-col>
                    <el-col :span="22">
                      <div class="grid-content bg-purple-light">{{ curriculumInfo.brief_content }}</div>
                    </el-col>
                  </el-row>
                </div>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="24">
                <div class="classlist">
                  <el-tabs v-model="activeName">
                    <el-tab-pane label="物料说明" name="first">
                      <div class="video_content" v-if="curriculumInfo.main_content">
                        <mavon-editor v-model="curriculumInfo.main_content" defaultOpen="preview" :boxShadow="false" :editable="false" :subfield="false" :toolbarsFlag="false"></mavon-editor>
                      </div>
                    </el-tab-pane>

                    <el-tab-pane label="文件列表" name="third">
                      <el-table size="small" :data="tableData" :header-cell-style="{ background: '#f5f7fa' }">
                        <el-table-column prop="file_type" label="类型" width="100px"></el-table-column>
                        <el-table-column prop="title" label="名称"></el-table-column>
                        <el-table-column prop="file_size" label="大小"></el-table-column>
                        <el-table-column prop="download_num" label="下载"></el-table-column>

                        <el-table-column prop="created_time" label="创建时间"></el-table-column>
                        <el-table-column align="center" label="操作">
                          <template slot-scope="scope">
                            <el-button size="small" type="text" @click="download(scope.row)">下载</el-button>
                            <el-button v-if="scope.row.file_type != '其他' && scope.row.file_type != 'ai' && scope.row.file_type != 'psd'" size="small" type="text" @click="preview(scope.row)">预览</el-button>
                          </template>
                        </el-table-column>
                      </el-table>
                      <el-row :gutter="20" style="margin:20px auto">
                        <el-col :span="12" :offset="10">
                          <el-button v-if="this.zip_url === '' ? false : true" type="primary" plain @click="downloadAll">下载全部</el-button>
                        </el-col>
                      </el-row>
                    </el-tab-pane>
                  </el-tabs>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
    </div>
    <div style="position: fixed; bottom: 15px; right: 30px; width: calc(100% - 260px); z-index: 9999; box-sizing: border-box;">
      <div class="rightBtn" v-if="activeName == 'first'" @click="activeName = 'third'">下 载</div>
    </div>
    <el-dialog :visible.sync="dialogVisible" width="80%">
      <el-image :src="url"></el-image>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { meterialInfo, downloadNum } from "@/api/operationalActivitiesPc.js";
// import { utilDownloadFile } from '@/utils/utils'

export default {
  data() {
    return {
      dialogVisible: false,
      url: "",
      allurl: "",
      //页码管理
      page_no: 1,
      page_size: 10,
      total: 0,
      curriculumInfo: {},
      base_meterial_id: "",
      tagList: [],
      tableData: [],
      zip_url: "",
      activeName: "first",
      toolbars: {
        bold: true, // 粗体
        italic: true, // 斜体
        header: true, // 标题
        underline: true, // 下划线
        strikethrough: true, // 中划线
        mark: true, // 标记
        superscript: true, // 上角标
        subscript: true, // 下角标
        quote: true, // 引用
        ol: true, // 有序列表
        ul: true, // 无序列表
        link: true, // 链接
        imagelink: true, // 图片链接
        code: true, // code
        table: true, // 表格
        fullscreen: true, // 全屏编辑
        readmodel: true, // 沉浸式阅读
        htmlcode: true, // 展示html源码
        help: true, // 帮助
        /* 1.3.5 */
        undo: true, // 上一步
        redo: true, // 下一步
        trash: true, // 清空
        save: true, // 保存（触发events中的save事件）
        /* 1.4.2 */
        navigation: true, // 导航目录
        /* 2.1.8 */
        alignleft: true, // 左对齐
        aligncenter: true, // 居中
        alignright: true, // 右对齐
        /* 2.2.1 */
        subfield: true, // 单双栏模式
        preview: true // 预览
      }
    };
  },
  created() {
    console.log(this.$route.query.id);
    this.base_meterial_id = this.$route.query.id;
    this.text = this.$route.query.title;
  },
  mounted() {
    this.meterialInfo();
  },
  methods: {
    //预览
    preview(row) {
      console.log(row, 56565);
      this.url = row.download_url;

      this.dialogVisible = true;
      // window.open(row.download_url);
    },

    download(row) {
      console.log(row)
      downloadNum({
        base_meterial_file_id: row.id
      }).then(async () => {
        const suffixArr = row.download_url.split('.');
        const suffix = suffixArr[suffixArr.length - 1];
        let link = document.createElement('a')
        link.href = row.download_url;
        if (suffix !== 'zip') {
          const response = await fetch(row.download_url, {
            mode: 'cors', // 强制启用 CORS
          });
          const blob = await response.blob();
          link.href = URL.createObjectURL(blob);
        }
        link.setAttribute('download', `${row.title}`)
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setTimeout(() => {
          // this.$message.success("下载成功");
          this.meterialInfo();
        }, 2000)
        // const res = await utilDownloadFile(row.download_url, row.title)
        // console.log(res)
      });
    },
    meterialInfo() {
      meterialInfo({
        base_meterial_id: this.base_meterial_id
      }).then(res => {
        this.curriculumInfo = res.baseMeterial;
        this.tagList = this.curriculumInfo.typeNameArr;
        this.tableData = this.curriculumInfo.fileInfoArr;
        this.zip_url = res.baseMeterial.zip_url;
        console.log(this.zip_url, 5987);
        this.tableData.map(item => {
          if (item.file_type === 100) {
            return (item.file_type = "其他");
          }
          if (item.file_type === 1) {
            return (item.file_type = "png");
          }
          if (item.file_type === 2) {
            return (item.file_type = "jpg/jpeg");
          }
          if (item.file_type === 3) {
            return (item.file_type = "pdf");
          }
          if (item.file_type === 4) {
            return (item.file_type = "doc");
          }
          if (item.file_type === 5) {
            return (item.file_type = "psd");
          }
          if (item.file_type === 6) {
            return (item.file_type = "ai");
          }
        });
      });
    },
    downloadAll() {
      window.open(this.zip_url);
    }
  }
};
</script>

<style>
.el-dialog {
  width: 900px;
}

.v-show-content {
  background: white !important;
}
</style>

<style lang="scss" scoped>
.rightBtn {
  margin: 0 auto;
  width: 150px;
  // position: fixed;
  // left: 50%;
  // margin-left: -75px;
  // bottom: 15px;
  padding: 6px 8px;
  border-radius: 7px 7px 7px 7px;
  // z-index: 9999;
  background-color: #1778ff;
  color: #fff;
  text-align: center;
  cursor: pointer;
  box-sizing: border-box;
}

.tagName {
  color: rgb(241, 90, 36);
  font-size: 10px;
  border: 1px solid rgb(241, 90, 36);
  padding: 2px 4px;
  border-radius: 5px;
}

/deep/ .el-image {
  left: 50%;
  -webkit-transform: translate(-50%);
  -moz-transform: translate(-50%);
  transform: translate(-50%);
}

.container {
  width: 100%;
  height: 100%;
  min-width: 1000px;

  .school-body {
    padding: 10px;

    .classwrapper {
      border-radius: 5px;
      background: white;

      .classheader {
        margin-top: 15px;
        margin-left: 15px;
      }

      .classlist {
        padding-left: 20px;

        .classlist_wrapper {
          padding-top: 20px;
          padding-bottom: 20px;

          .classlist-imgwrapper {
            width: 100%;

            .classimg_wrapper_img {
              width: 100%;
              border-radius: 5px;
            }
          }

          .classlist-content {
            .classlist-content-title {
              padding-left: 40px;
              font-weight: 500;
              line-height: 40px;
              font-size: 14px;

              .coursetitle {
                padding-right: 10px;
                font-weight: bold;
                font-size: 14px;
              }
            }

            .classlist-content-desc {
              padding-left: 40px;
              padding-right: 40px;

              text-overflow: -o-ellipsis-lastline;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 1;
              -webkit-box-orient: vertical;

              .content-desc {
                padding-right: 20px;
              }
            }
          }

          .classlist-btn {
            margin-top: 30%;
          }
        }

        .classlist_wrapper::-webkit-scrollbar {
          /*隐藏滚轮*/
          display: none;
        }
      }

      .classimg_wrapper {
        height: 0;
        padding-bottom: 69%;
        background-repeat: no-repeat;
        background-size: cover;
        border-radius: 5px 5px 5px 5px;
      }

      .classdesc_wrapper {
        margin-left: 40px;

        .classdesc_title {
          font-size: 20px;
          padding-bottom: 10px;
        }
      }
    }
  }
}
</style>